import React from 'react';
import './CheckoutPayment.css';
import { Utils } from '../../Utils';
import i18n from '../../i18n/i18n.js';

class CheckoutPayment extends React.Component {
  
  state = {
    selectedPaymentMethod: null,
    expandedMethods: {}, // Mely elemek vannak kinyitva
    hasSelectedDeliveryMethod: false,
  };

  errorRef = React.createRef();

  componentDidMount() {
    // Inicializáljuk az értékeket a formData-ból ha vannak
    const { formData,fullFormResponse } = this.props;

    if (formData && formData.payment_method_id) {
      this.setState({ 
        selectedPaymentMethod: formData.payment_method_id,
        expandedMethods: { [formData.payment_method_id]: true }, // Kiválasztott elem automatikusan nyitva
        hasSelectedDeliveryMethod: !!formData.delivery_method_id
      });
    }
  }

  componentDidUpdate(prevProps) {
    // Ha a formData megváltozott és van benne payment_method_id, frissítjük a state-et
    const { formData, formErrors } = this.props;
    
    const newHasSelectedDeliveryMethod = !!formData?.delivery_method_id && formErrors?.delivery_method === undefined;
    
    const shouldUpdate = 
      (formData && (formData.payment_method_id !== prevProps.formData?.payment_method_id || formData.delivery_method_id !== prevProps.formData?.delivery_method_id)) ||
      (newHasSelectedDeliveryMethod !== this.state.hasSelectedDeliveryMethod);
    
    if (shouldUpdate) {
      this.setState({ 
        selectedPaymentMethod: formData.payment_method_id,
        expandedMethods: { ...this.state.expandedMethods, [formData.payment_method_id]: true },
        hasSelectedDeliveryMethod: newHasSelectedDeliveryMethod
      });
    }

    // Ha megjelent egy hiba, görgessünk hozzá
    const hasError = formErrors && (formErrors.payment_method_id || formErrors.payment_method);
    const hadError = prevProps.formErrors && (prevProps.formErrors.payment_method_id || prevProps.formErrors.payment_method);
    
    if (hasError && !hadError && this.errorRef.current) {
      setTimeout(() => {
        this.errorRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 100);
    }
  }

  /**
   * KÖTELEZŐ metódus - ezt hívja meg a Form komponens az elküldéskor
   */
  getFormData() {
    return {
      payment_method_id: this.state.selectedPaymentMethod
    };
  }

  /**
   * A blokkhoz tartozó hibaüzenet-kulcsok, ezek tartják nyitva a szerkesztő panelt
   */
  getErrorFieldnames() {
    return ['payment_method_id', 'payment_method'];
  }

  handlePaymentMethodChange = (methodId) => {
    this.setState({ 
      selectedPaymentMethod: methodId,
      expandedMethods: { ...this.state.expandedMethods, [methodId]: true },
      hasSelectedDeliveryMethod: !!this.props.formData?.delivery_method_id && this.props.formErrors?.delivery_method === undefined
    });
  }

  toggleMethodExpanded = (methodId) => {
    this.setState(prevState => ({
      expandedMethods: {
        ...prevState.expandedMethods,
        [methodId]: !prevState.expandedMethods[methodId]
      }
    }));
  }

  getPaymentMethods = () => {
    const { fullFormResponse } = this.props;
    
    if (!fullFormResponse || !fullFormResponse.payment_delivery_methods || !fullFormResponse.payment_delivery_methods.payment_methods) {
      return {};
    }
    
    return fullFormResponse.payment_delivery_methods.payment_methods;
  }

  formatPaymentPrice = (method) => {
    const { appRef } = this.props;
    
    if (!method) return '';
    
    // Ha a method.free flag true, akkor ingyenes
    if (method.free) {
      return i18n.t('checkoutPaymentFree');
    }
    
    // Különben formázzuk az árat
    const costs = method.cost_gross;
    
    if (costs && costs !== '0' && costs !== 0) {
      return appRef?.current ? Utils.format_currency(costs, appRef.current.currency_settings) : method.payment_costs;
    }
    
    return i18n.t('checkoutPaymentFree');
  }

  render() {
    const { blockData, formData, formErrors, summaryMode, onOpenEditor, fullFormResponse, appRef } = this.props;
    const { selectedPaymentMethod, expandedMethods, hasSelectedDeliveryMethod } = this.state;
    
    const paymentMethods = this.getPaymentMethods();

    if (summaryMode) {
      // Summary nézet
      const hasSelectedMethod = selectedPaymentMethod && selectedPaymentMethod !== null;
      const hasError = formErrors && (formErrors.payment_method_id || formErrors.payment_method);
      const buttonText = hasSelectedMethod ? i18n.t('checkoutPaymentEdit') : i18n.t('checkoutPaymentSelect');
      
      // Kiválasztott módszer neve és ára
      let selectedMethodName = '';
      let selectedMethodPrice = '';
      if (hasSelectedMethod && paymentMethods && paymentMethods[selectedPaymentMethod]) {
        selectedMethodName = paymentMethods[selectedPaymentMethod].payment_method || '';
        selectedMethodPrice = this.formatPaymentPrice(paymentMethods[selectedPaymentMethod]);
      }
      
      return (
        <div className={`checkout_payment_summary ${hasError ? 'has_error' : ''}`}>
          <div className="block_header">
            <h3 className="block_title">{blockData.label ? blockData.label.replace(/<[^>]*>/g, '') : 'Fizetési mód'}</h3>
          </div>
          {hasError && (
            <div className="block_summary_error">
              {formErrors.payment_method_id && (
                <div className="form_error" dangerouslySetInnerHTML={{__html: formErrors.payment_method_id}}></div>
              )}
              {formErrors.payment_method && (
                <div className="form_error" dangerouslySetInnerHTML={{__html: formErrors.payment_method}}></div>
              )}
            </div>
          )}
          {hasSelectedMethod && (
            <div className="summary_content">
              <p>{selectedMethodName}</p>
              <p>{selectedMethodPrice}</p>
            </div>
          )}
          {hasSelectedDeliveryMethod ?
            <button type="button" className="select_button" onClick={onOpenEditor}>{buttonText}</button>
            :
            <div className="delivery_required_message">{i18n.t('checkoutPaymentSelectDeliveryFirst')}</div>
          }
        </div>
      );
    }

    // Normál/Edit nézet
    const hasError = formErrors && (formErrors.payment_method_id || formErrors.payment_method);
    const hasSelectedMethod = selectedPaymentMethod && selectedPaymentMethod !== null;
    
    return (
      <div className="checkout_payment_block">
        {/* Ha nincs kiválasztott elem, a hiba a lista tetején */}
          {hasError && !hasSelectedMethod && (
            <div className="form_error" ref={this.errorRef}>
              {formErrors.payment_method_id && (
                <div dangerouslySetInnerHTML={{__html: formErrors.payment_method_id}}></div>
              )}
              {formErrors.payment_method && (
                <div dangerouslySetInnerHTML={{__html: formErrors.payment_method}}></div>
              )}
            </div>
          )}

        <div className="payment_methods">
          
          {paymentMethods && Object.keys(paymentMethods).length > 0 ? (
            <div className="payment_methods_list">
              {Object.keys(paymentMethods).map(methodId => {
                const method = paymentMethods[methodId];
                const isSelected = selectedPaymentMethod === methodId;
                const isExpanded = expandedMethods[methodId] || false;

                if(!method['selectable']){
                  return false;
                }
                
                return (
                  <div key={methodId} className={`payment_method_item ${isSelected ? 'selected' : ''}`}>
                    <div className="payment_method_header">
                      <input
                        type="radio"
                        name="payment_method_id"
                        value={methodId}
                        checked={isSelected}
                        onChange={() => this.handlePaymentMethodChange(methodId)}
                      />
                      <label className="method_info" onClick={() => this.handlePaymentMethodChange(methodId)}>
                        <div className="method_name">{method.payment_method || ''}</div>
                        <div className="method_price">{this.formatPaymentPrice(method)}</div>
                      </label>
                      <div 
                        className={`chevron_icon ${isExpanded ? 'expanded' : ''}`}
                        onClick={(e) => {
                          e.preventDefault();
                          this.toggleMethodExpanded(methodId);
                        }}
                      >
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M7 10L12 15L17 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </div>
                    </div>
                    
                    {/* Ha ez a kiválasztott elem, a hiba itt jelenik meg */}
                    {hasError && isSelected && (
                      <div className="form_error" ref={this.errorRef}>
                        {formErrors.payment_method_id && (
                          <div dangerouslySetInnerHTML={{__html: formErrors.payment_method_id}}></div>
                        )}
                        {formErrors.payment_method && (
                          <div dangerouslySetInnerHTML={{__html: formErrors.payment_method}}></div>
                        )}
                      </div>
                    )}
                    
                    {isExpanded && method.payment_content && (
                      <div className="method_description" dangerouslySetInnerHTML={{ __html: method.payment_content }} />
                    )}
                    
                  </div>
                );
              })}
            </div>
          ) : (
            <p>{i18n.t('checkoutPaymentNoMethods')}</p>
          )}
        </div>
      </div>
    );
  }
}

export default CheckoutPayment;
